module.exports = __webpack_public_path__ + "img/r-241.57bf152c.jpg";